// extracted by mini-css-extract-plugin
module.exports = {"root":"Deals_qmee_root__tOFAp"};